import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger)

class CTA {
    private background: HTMLElement;
    private logo: HTMLElement;

    constructor(private element: HTMLElement) {
        if (!this.element) return;
        this.init();
    }

    private init() {
        this.background = this.element.querySelector<HTMLElement>('.component-background');
        if (!this.background) return;

        this.logo = this.background.querySelector<HTMLElement>('svg');
        if (!this.logo) return;

        this.logo.style.transformOrigin = 'right bottom';

        ScrollTrigger.create({
            trigger: this.logo,
            start: "top bottom",
            end: "bottom bottom",
            scrub: true,
            onUpdate: (self) => {
                this.logo.style.transform = `scale(${0.5 + (self.progress / 2)})`;
            },
        });
    }
}

window.addEventListener("load", () => {
    const ctaElements = document.querySelectorAll<HTMLElement>(".cta-component");
    ctaElements?.forEach((cta) => {
        new CTA(cta);
    });
});